import type { TFunction } from "i18next";
import { formatDate } from "@/lib/utils";
import { parseYmd } from "../types";

/** Payment-method codes with a translated name (sales store the company's method code, e.g. "mada"). */
const PAYMENT_METHOD_KEYS: Record<string, string> = {
	cash: "cash",
	card: "card",
	mada: "mada",
	network: "card",
	apple_pay: "applePay",
	applepay: "applePay",
	stc_pay: "stcPay",
	stcpay: "stcPay",
	gift_card: "giftCard",
	giftcard: "giftCard",
	bnpl: "bnpl",
	tabby: "tabby",
	tamara: "tamara",
	bank_transfer: "bankTransfer",
	check: "check",
	credit: "credit",
	loyalty: "loyalty",
	split: "split",
};

/** Readable name of a payment-method code; unknown custom codes are humanized ("pay_later" → "Pay later"). */
export function paymentMethodLabel(t: TFunction, code: string | null | undefined): string {
	if (!code) return t("reports.paymentMethods.unknown");
	const key = PAYMENT_METHOD_KEYS[code.toLowerCase()];
	if (key) return t(`reports.filters.paymentMethods.${key}`);
	const words = code.replace(/[_-]+/g, " ").trim();
	return words.charAt(0).toUpperCase() + words.slice(1);
}

/** "01/10/2026 – 18/10/2026", or a single date when both ends are the same day. */
export function rangeText(range: { startDate?: string; endDate?: string }): string {
	const start = parseYmd(range.startDate);
	const end = parseYmd(range.endDate);
	if (!start || !end) return "";
	return range.startDate === range.endDate ? formatDate(start) : `${formatDate(start)} – ${formatDate(end)}`;
}

/** Translated status of a document, falling back to the raw value when the key is missing. */
export function statusLabel(t: TFunction, prefix: string, status: string | null | undefined): string {
	if (!status) return "-";
	return t(`${prefix}.${status}`, { defaultValue: status });
}
